module.exports = __webpack_public_path__ + "img/list_8_tc.0e3e0610.png";